// extracted by mini-css-extract-plugin
export default {"container":"tab_container__aBTZR","container_tab":"tab_container_tab__TlKw0","tab":"tab_tab__zQ0Pi","tab_selected":"tab_tab_selected__MpMuL","title":"tab_title__3Rk-S"};